import { proxy } from 'valtio';

const componentSearchBar = proxy<{ query: string }>({ query: '' });

export { componentSearchBar };
